var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MarginInput',{attrs:{"options":_vm.options,"open":_vm.open}}),_vm._v(" "),_c('BackgroundAndTextColorInput',{attrs:{"options":_vm.options}}),_vm._v(" "),_c('AnchorInput',{attrs:{"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }